export const STATUS_COLORS = {
  // Project Statuses
  'Completed': '#4CAF50',
  'Initiated': '#FFA500',
  'In-Progress': '#FFA500',
  'On-Hold': '#9C27B0',
  'Cancelled': '#FF0000',
  'Closed': '#707070',
  // Blue-grey: reads as "exists but not started", and stays distinct from the
  // orange in-progress / green complete / grey inactive chips.
  'Created': '#607D8B',
  // Campaign Statuses
  'Complete': '#4CAF50',
  'Ongoing': '#FFA500',
  'Delayed': '#9C27B0',
  'Pending': '#800000',
  'Inactive': '#A9A9A9',
  // Legacy/Other
  'Confirmed': '#4CAF50',
  'On Hold': '#9C27B0',
  'Under Confirmation': '#FFA500',
  'Planned': '#2196F3',
};

// Shown when a campaign/project exists but carries no status yet — the API
// transform turns a missing status into '' (see dashboardAPI), which previously
// rendered as an empty black chip.
export const DEFAULT_STATUS_LABEL = 'Created';

// Any status not in STATUS_COLORS. Deliberately a visible grey, never black:
// a black chip with white text reads as a rendering bug, not a status.
export const STATUS_COLOR_FALLBACK = '#9E9E9E';

// Search-by criteria mapped to the main-dashboard table column headings
// (R28 — "Search by Column Headings"). Values are sent to the backend as
// `searchByField`; labels mirror the visible column headers per the PPT/doc.
export const SEARCH_CRITERIA_OPTIONS = [
  { value: 'all', label: 'Select Criteria' },
  // Labels only — `value` is the backend `searchByField` and must not change.
  { value: 'projectId', label: 'Sponsor Project ID' },
  { value: 'productDescription', label: 'Sponsor Product Description' },
  { value: 'poNumber', label: 'PO Number' },
  { value: 'campaignId', label: 'Campaign ID' },
  { value: 'campaignStatus', label: 'Campaign Status' },
  { value: 'startDate', label: 'Start Date' },
  { value: 'expectedEndDate', label: 'Expected End Date' },
];

export const ROWS_PER_PAGE_OPTIONS = [3, 5, 10, 15, 30];

export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_FILTERS = {
  cmoSite: 'all',
  deliverableType: 'all',
  searchCriteria: 'all',
  searchValue: '',
};

export const MOCK_ACTIVE_BATCHES_DATA = [
  {
    batchNumber: 'DBSQC26008',
    cmoSite: 'Sai - Unit-IV',
    projectId: '13762',
    productDescription: 'BSQ Stage-C',
    cmoStage: 'Stage C',
    chemicalNumber: '(MIR-006432)',
    completed: 'DSSR57, DGLB05, DSCF23',
    ongoing: 'DSCF18, DGLB05, DRVD08',
    onHold: '',
    timestamp: '12-MAR-2026 17:15:42',
  },
  {
    batchNumber: 'DBSQC26011',
    cmoSite: 'Sai - Unit-IV',
    projectId: '13762',
    productDescription: 'BSQ Stage-C',
    cmoStage: 'Stage C',
    chemicalNumber: '(MIR-006432)',
    completed: 'DGLR64, DGLB04-1, DSCF15',
    ongoing: 'DGLB04-1, DRVD08',
    onHold: '',
    timestamp: '24-MAR-2026 07:14:56',
  },
  {
    batchNumber: 'DBSQC26012',
    cmoSite: 'Sai - Unit-IV',
    projectId: '13762',
    productDescription: 'BSQ Stage-C',
    cmoStage: 'Stage C',
    chemicalNumber: '(MIR-006432)',
    completed: 'DSSR57, DGLB05, DSCF23',
    ongoing: 'DSCF18, DGLB05, DRVD08',
    onHold: '',
    timestamp: '26-MAR-2026 15:20:25',
  },
];

